import { FormControl, FormLabel, Text } from "@chakra-ui/react";
import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";
import Select from "react-select";
import { useQuery } from "@apollo/client";
import { GET_CITIES } from "./queries";
import { get } from "lodash";

type Option = {
  value: any;
  label: any;
  province_code?: string;
};
interface SelectCityFieldFieldProps extends DefaultFieldProps {
  defaultVal?: any;
  options: Option[];
  menuPortalTarget?: any;
  selectMenuPosition?: any;
  selectMenuPortalzIndex?: number;
  selectCustomStyles?: any;
  isDisabled?: boolean;
  isLoading?: boolean;
  isClearable?: boolean;
  onChange: () => {};
}

const SelectCityFieldField: FC<
  FieldRenderProps<SelectCityFieldFieldProps & any>
> = (props) => {
  const {
    defaultVal,
    formGroupProps,
    labelProps,
    errorProps,
    label,
    meta,
    input,
    menuPortalTarget = null,
    selectMenuPosition = "absolute",
    selectMenuPortalzIndex = 3000,
    selectCustomStyles,
    isDisabled,
    isClearable,
    onChange,
    province_code,
  } = props;

  const { data, loading } = useQuery(GET_CITIES, {
    variables: {
      province_code,
    },
    fetchPolicy: "network-only",
    skip: !province_code,
  });

  const cities = get(data, "cities", []);

  const options = cities.map((city: any) => {
    return {
      label: city.city_name,
      value: city.city_code,
    };
  });

  return (
    <FormControl {...formGroupProps} position="relative">
      <FormLabel {...labelProps}>{label}</FormLabel>
      <Select
        {...input}
        value={options.find((option: any) => option.value === input.value)}
        className="basic-single"
        classNamePrefix="select"
        isDisabled={isDisabled}
        isLoading={loading}
        isClearable={isClearable}
        styles={{
          ...selectCustomStyles,
          menuPortal: (styles: any) => {
            return {
              ...styles,
              zIndex: selectMenuPortalzIndex,
            };
          },
        }}
        defaultValue={defaultVal}
        isSearchable={true}
        options={options}
        noOptionsMessage={() => "No Options available."}
        menuPortalTarget={menuPortalTarget}
        menuPosition={selectMenuPosition}
        onChange={(val: any) => {
          input.onChange(val.value);
          onChange(val.value);
        }}
      />
      {meta.error && meta.touched && (
        <Text
          {...errorProps}
          color="red.300"
          fontSize="sm"
          textAlign="end"
          mx="3"
          position="absolute"
          right={0}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default SelectCityFieldField;
